/**
 *
 * @export
 * @interface LinkDataDefinition
 */
export interface LinkDataDefinition {
  /**
   * id of item we wish to link the RFI to
   * @type {string}
   * @memberof LinkDataDefinition
   */
  linkedItemId: string;
  /**
   * the type of item we wish to link the RFI to
   * @type {string}
   * @memberof LinkDataDefinition
   */
  linkedItemType: LinkedItemType;
}

/**
 * @export
 * @enum {string}
 */
export enum LinkedItemType {
  Pco = 'pco',
  Documentlineage = 'documentlineage',
  Sheetlineage = 'sheetlineage',
  Photo = 'photo',
}

/**
 *
 * @export
 * @interface ReferenceDataDefinition
 */
export interface ReferenceDataDefinition {
  /**
   * id of item we wish to link the RFI to
   * @type {string}
   * @memberof ReferenceDataDefinition
   */
  id: string;
  /**
   * the type of item we wish to link the RFI to
   * @type {string}
   * @memberof ReferenceDataDefinition
   */
  type: ReferenceType;
  /**
   *
   * @type {string}
   * @memberof ReferenceDataDefinition
   */
  domain: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ReferenceType {
  Rfi = 'rfi',
  Pco = 'pco',
  Documentlineage = 'documentlineage',
  Sheetlineage = 'sheetlineage',
  Photo = 'photo',
}
